import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = (props, ref) => <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" id="Layer_1" x="0px" y="0px" viewBox="0 0 512 512" style={{
  enableBackground: "new 0 0 512 512"
}} xmlSpace="preserve" ref={ref} {...props}><path style={{
    fill: "#73AF00"
  }} d="M38.345,423.724h435.31c21.177,0,38.345-17.167,38.345-38.345v-73.471L20.404,419.268  C25.758,422.109,31.861,423.724,38.345,423.724z" /><path style={{
    fill: "#41479B"
  }} d="M38.345,88.276C17.167,88.276,0,105.443,0,126.621V385.38c0,8.681,2.888,16.684,7.751,23.111  L170.666,88.276H38.345z" /><path style={{
    fill: "#FFE15A"
  }} d="M170.666,88.276L7.751,408.49c1.097,1.449,2.293,2.819,3.581,4.098L341.333,88.276H170.666z" /><path style={{
    fill: "#FF4B55"
  }} d="M473.655,88.276H341.333L11.331,412.588c1.497,1.487,3.122,2.845,4.847,4.069L512,200.092v-73.471  C512,105.443,494.833,88.276,473.655,88.276z" /><path style={{
    fill: "#F5F5F5"
  }} d="M20.404,419.268L512,311.908V200.092L16.178,416.658C17.526,417.614,18.935,418.489,20.404,419.268z" /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /></svg>;
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };